var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4781812_bin_delete_file_garbage_recycle_icon",
    "data-name": "4781812_bin_delete_file_garbage_recycle_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2.446 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15654",
    "data-name": "Path 15654",
    d: "M13.36,19.806H9.446A2.446,2.446,0,0,1,7,17.36v-5.87a.489.489,0,0,1,.978,0v5.87a1.468,1.468,0,0,0,1.468,1.468H13.36a1.468,1.468,0,0,0,1.468-1.468v-5.87a.489.489,0,0,1,.978,0v5.87A2.446,2.446,0,0,1,13.36,19.806Z",
    transform: "translate(-6.022 -7.086)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15655",
    "data-name": "Path 15655",
    d: "M15.273,7.978H5.489a.489.489,0,0,1,0-.978h9.784a.489.489,0,0,1,0,.978Z",
    transform: "translate(-5 -5.043)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15656",
    "data-name": "Path 15656",
    d: "M15.4,5.935H11.489A.489.489,0,0,1,11,5.446V4.468A1.468,1.468,0,0,1,12.468,3h1.957a1.468,1.468,0,0,1,1.468,1.468v.978A.489.489,0,0,1,15.4,5.935Zm-3.424-.978h2.935V4.468a.489.489,0,0,0-.489-.489H12.468a.489.489,0,0,0-.489.489Z",
    transform: "translate(-8.065 -3)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15657",
    "data-name": "Path 15657",
    d: "M13.489,18.4A.489.489,0,0,1,13,17.914V14.489a.489.489,0,1,1,.978,0v3.424A.489.489,0,0,1,13.489,18.4Z",
    transform: "translate(-9.086 -8.619)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15658",
    "data-name": "Path 15658",
    d: "M17.489,18.4A.489.489,0,0,1,17,17.914V14.489a.489.489,0,1,1,.978,0v3.424A.489.489,0,0,1,17.489,18.4Z",
    transform: "translate(-11.13 -8.619)",
    fill: "#ff5656"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    "data-name": "Rectangle 1957",
    width: 16,
    height: 16,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.66756ed7f3c49558a6d854f1dc0032e0.svg";
export { ForwardRef as ReactComponent };